<template>
  <div class="modal fade" id="password-modal" role="dialog" :data-backdrop="backdrop">
    <div class="modal-dialog">
      <div class="modal-content content">
        <div class="modal-header">
          <a v-if="!removeCloseButton" type="button" class="close-btn-password" data-dismiss="modal">
            <ion-icon name="close"></ion-icon>
          </a>
          <div class="title-group">
            <ion-icon name="lock-open-outline"></ion-icon>
            <h4 class="title-modal">{{ titleModal }}</h4>
          </div>
          <div class="subtitle">
            <span>{{ subtitleModal }}</span>
          </div>
        </div>
        <div class="modal-body">
          <div class="password-validate">
            <input type="password" id="input-password" v-model="modalPassword" autocomplete="off"
                   placeholder="Digite a senha"/>
            <button class="btn-validate" @click="passwordValidation()" data-dismiss="modal" data-backdrop="false"
                    :disabled="disabledButton && modalPassword.length === 0">
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modalPassword",
  props: {
    titleModal: {
      required: true
    },
    subtitleModal: {
      required: true
    },
    runFunction: {
      type: Function,
    },
    disabledButton: {
      default: false,
    },
    backdrop: {
      default: 'modal',
    },
    removeCloseButton: {
      default: false,
    }
  },
  data() {
    return {
      modalPassword: '',
      valuePassword: '',
    };
  },
  methods: {
    passwordValidation() {
      $("#password-modal").toggle("");
      this.valuePassword = document.querySelector("[id='input-password']").value
      this.runFunction(this.valuePassword);
    },
  }
}
</script>

<style lang="scss" scoped>

#password-modal {
  .modal-dialog {
    width: 500px;
    margin-top: 15%;

    .content {
      border: none;
      box-shadow: none;
      border-radius: 8px !important;

      .modal-header {
        position: relative;
        padding: 20px 30px;
        border-bottom: none;

        .title-group {
          display: flex;
          align-items: flex-end;

          ion-icon {
            margin-right: 5px;
            font-size: 23px;
            color: var(--dark-gray);
          }

          .title-modal {
            margin: 0;
            text-align: left;
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: 700;
            color: var(--classic-black);
          }
        }

        .subtitle {
          span {
            margin-top: 5px;
            margin-left: 4px;
            font-size: 14px;
            font-weight: 400;
            color: var(--dark-gray);
          }
        }

        .close-btn-password {
          position: absolute;
          right: 26px;
          top: 16px;
          height: 20px;
          color: var(--light-red);

          &:hover {
            color: var(--high-red);
          }

          ion-icon {
            font-size: 20px;
            pointer-events: none;
          }
        }
      }

      .modal-body {
        padding: 0 30px 20px;

        .password-validate {
          display: flex;
          position: relative;

          ion-icon {
            position: absolute;
            right: 10px;
            top: 10px;
            font-size: 16px;
            color: var(--dark-gray);
          }

          input {
            width: 100%;
            background: #EEF2F7;
            border-radius: 4px !important;
            padding: 6px 12px;
            border: 1px solid #EEF2F7;
            transition: .2s;
            margin-right: 20px;

            font-size: 16px;
            font-weight: 400;
            color: var(--dark-gray);

            &::placeholder {
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
            }

            &:hover {
              transition: .2s;
              border: 1px solid #CACACA;
            }

            &:focus-visible {
              outline: none;
              transition: .2s;
              border: 1px solid #CACACA;

              &::placeholder {
                transition: .1s;
                color: #EEF2F7;
              }
            }
          }
        }

        .btn-validate {
          background: #2F23D6;
          color: #FFFFFF;
          border-radius: 4px !important;
          border: none;
          padding: 0 20px;

          &:hover {
            background: #20179E;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalPassword.vue